import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

let state = {
    loading: 0,
    screenWidth: null,
    bodyHeight: null,
    scroll: 0,
    user: null,
    errors: [],
    messages: [],
    warnings: [],
    webp: '',
    icons: {},
    active: {},
    pageData: null,
    captchas: {},
    notFound: false,
    seo: {},
    serverFetched: false,
    mobile: false,
    updateBodyHeight() {
        const foot = document.querySelector('.main-footer');
        if(foot){
            const footerTop = parseInt(window.getComputedStyle(foot).getPropertyValue('margin-top').match(/\d+/)[0]);
            const footerBottom = parseInt(window.getComputedStyle(foot).getPropertyValue('margin-bottom').match(/\d+/)[0]);
            this.bodyHeight = window.innerHeight - 6 /*- head.getBoundingClientRect().height*/ - foot.getBoundingClientRect().height - footerTop - footerBottom;
        }
    },
    updateScroll() {
        this.scroll = window.scrollY;
    }
};

export default function createStore() {
    return new Vuex.Store({
        state: () => state
    })
};